<template>
  <main class="auth-page single-film-prototype">
    <section :class="topSectionClasses">
      <HeroTopPanel
        :logo-src="assets.logo"
        :background-src="defaultBackgroundImage"
        :background-wrap-style="heroBackgroundStyle"
        :show-background="showHero"
        login-path="/login"
        @open-mobile-search="openMobileSearchOverlay"
      >
        <div v-if="showHero" class="row g-0 auth-hero__main">
          <div class="col">
            <div class="auth-hero__copy">
              <h1 class="item-title" data-testid="auth-page-title">{{ title }}</h1>
              <p v-if="subtitle" class="auth-hero__subtitle" data-testid="auth-page-subtitle">{{ subtitle }}</p>
            </div>
          </div>
        </div>
      </HeroTopPanel>
    </section>

    <div class="middle-section auth-section">
      <div class="container g-0">
        <div class="row">
          <div class="col-md-12 col-lg-10 auth-content-column">
            <section class="auth-panel" data-testid="auth-panel">
              <slot />
            </section>
          </div>
        </div>
      </div>
    </div>

    <MobileSearchOverlay :open="mobileSearchOpen" @close="closeMobileSearchOverlay" />
  </main>
</template>

<script setup>
import { computed, ref } from 'vue'
import HeroTopPanel from './HeroTopPanel.vue'
import MobileSearchOverlay from './MobileSearchOverlay.vue'
import '../assets/single-film/bootstrap-lite.css'
import '../assets/single-film/styles.css'
import '../assets/auth/auth.css'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
  showHero: {
    type: Boolean,
    default: true,
  },
})

const defaultBackgroundImage = '/media/films/backgrounds/default-bg.jpg'
const assets = {
  logo: '/static/spa/branding/logo.png',
}

const mobileSearchOpen = ref(false)
const topSectionClasses = computed(() => [
  props.showHero ? 'hero auth-hero' : 'auth-page__top',
  'g-0',
  'position-relative',
])
const heroBackgroundStyle = computed(() => ({
  backgroundImage: `url('${defaultBackgroundImage}')`,
}))

function openMobileSearchOverlay() {
  mobileSearchOpen.value = true
}

function closeMobileSearchOverlay() {
  mobileSearchOpen.value = false
}
</script>
